import { render, staticRenderFns } from "./LeagueResultNext.vue?vue&type=template&id=dc78727e&scoped=true"
import script from "./LeagueResultNext.vue?vue&type=script&lang=js"
export * from "./LeagueResultNext.vue?vue&type=script&lang=js"
import style0 from "./LeagueResultNext.vue?vue&type=style&index=0&id=dc78727e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc78727e",
  null
  
)

export default component.exports